/**
 * SalesStatusPresenter
 * --
 */
import React, { useState, useEffect } from 'react';
import { Content, Row, Col, ModalLayout, Table } from 'components';
import { Button, Calendar, Select } from 'antd';
import { stringToMoneyFormat } from 'utils';
import dayjs from 'dayjs';
const SalesStatusPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    categoryData,
    isOpened,
    menuSales,
    dailySales,
    dailyRefundSales,
    dailyCouponSales,
    onOpen,
    setSelectday,
    modalType,
    setStartOfToday,
    setEndOfToday,
  } = props;
  /* ===== STATE ===== */
  const [selectedCategory, setSelectedCategory] = useState('');

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
    tabTitle: {
      fontSize: 14,
      fontWeight: 600,
      color: '#404040',
    },
  };

  // console.log(menuSales);
  /* ===== FUNCTION ===== */

  const filteredData = menuSales?.filter((item) => {
    const matchesCategory = selectedCategory
      ? item.product_category_id === parseInt(selectedCategory)
      : true;
    return matchesCategory;
  });
  // 날짜별 매출을 표시하는 함수
  const dateCellRender = (value) => {
    const date = value.format('YYYY-MM-DD');
    const sales = dailySales[date];
    const refundSales = dailyRefundSales[date];
    const couponSales = dailyCouponSales[date];

    return sales || refundSales || couponSales ? (
      <div
        style={{
          position: 'absolute',
          top: 30,
          bottom: 4,
          right: 4,
          maxHeight: '20vh', // 화면 높이에 비례한 최대 높이
          overflowY: 'auto', // 스크롤 가능
          textAlign: 'right',
          padding: '8px',
          color: '#333',
          fontSize: 12,
          fontWeight: 500,
          scrollbarWidth: 'thin', // Firefox용 얇은 스크롤바
          scrollbarColor: 'rgba(0,0,0,0.2) transparent', // 스크롤바 색상
        }}
        className="scroll-container"
      >
        <div style={{ color: '#aba6a6' }}>매출</div>
        <div>{`${sales?.toLocaleString() || 0}원`}</div>
        <div style={{ color: '#aba6a6' }}>취소/환불</div>
        <div>{`${refundSales?.toLocaleString() || 0}원`}</div>
        <div style={{ color: '#aba6a6' }}>쿠폰/할인</div>
        <div>{`${couponSales?.toLocaleString() || 0}원`}</div>
      </div>
    ) : null;
  };

  //켈린더 클릭 시 해당 일자에 대응하는 menuSales 데이터 수정한 모달
  const onCalendarSelect = (newValue) => {
    const selectedDate = dayjs(newValue).format('YYYY-MM-DD');
    setSelectday(selectedDate); // 상태 업데이트
  };

  // 달력이 표시하는 월이 바뀔 때(좌우 화살표 클릭, 연/월 선택 등) 실행
  const onPanelChange = (value, mode) => {
    // mode === 'month'일 때만 처리 (연도 선택 패널 등은 제외)
    if (mode === 'month') {
      const startOfMonth = value.startOf('month').unix();
      const endOfMonth = value.endOf('month').unix();
      // console.log(startOfMonth);
      // console.log(endOfMonth);
      setStartOfToday(startOfMonth);
      setEndOfToday(endOfMonth);
    }
  };
  /* ===== HOOKS ===== */
  /**
   * 카테고리 필터링 초기화
   * --
   */
  useEffect(() => {
    setSelectedCategory('');
  }, [menuSales]);
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={10}>
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={10}>
              <h4 style={{ ...styles.tabTitle, marginBottom: 10 }}>
                메뉴별 판매순위
              </h4>
              <div
                style={{
                  background: '#F4F4F4',
                  border: '1px solid #E6E6E6',
                  padding: '7px 10px',
                }}
              >
                {/* 제목 라벨 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{ color: '#B9B9B9', fontSize: 12, fontWeight: 500 }}
                  >
                    메뉴명
                  </div>
                  <div
                    style={{ color: '#B9B9B9', fontSize: 12, fontWeight: 500 }}
                  >
                    판매수량
                  </div>
                </div>

                {/* 동적으로 데이터를 순회하여 메뉴별 판매순위 표시 */}
                {menuSales?.length > 0 ? (
                  menuSales?.slice(0, 10)?.map((item, index) => (
                    <div
                      key={`item_${index}`}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingTop: 10,
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                          flex: 1,
                          fontSize: 16,
                          fontWeight: 500,
                          color: '#6E6E6E',
                          lineHeight: '150%',
                        }}
                      >
                        {/* 순위 표시 */}
                        <span
                          style={{
                            width: 20,
                            textAlign: 'right',
                            marginRight: 10,
                          }}
                        >
                          {index + 1}.
                        </span>
                        {/* 메뉴 이름 표시 */}
                        <p>{item.menu_name}</p>
                      </div>
                      {/* 판매수량 표시 */}
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 500,
                          color: '#6E6E6E',
                        }}
                      >
                        {item.num}
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      textAlign: 'center',
                      marginTop: 20,
                      color: '#B9B9B9',
                    }}
                  >
                    데이터가 없습니다.
                  </div>
                )}
              </div>

              {/* 전체 판매내역 보기 버튼 */}
              <Button
                type="primary"
                style={{
                  background: 'var(--primary-color)',
                  width: '100%',
                  marginTop: 10,
                }}
                onClick={() => onOpen(isOpened, 'menusales')}
              >
                판매내역 보기
              </Button>
              <Button
                type="default"
                style={{
                  width: '100%',
                  marginTop: 10,
                }}
                onClick={() => setSelectday(null)}
              >
                전체 판매내역
              </Button>
            </Content>
          </Col>

          <Col x={18}>
            <Content maxWidth={'100%'} padding={10}>
              <h4 style={{ ...styles.tabTitle }}>일별 판매량</h4>
              <div style={{ position: 'relative' }}>
                <style>
                  {`.custom-calendar .ant-radio-group {display: none !important;}`}
                </style>
                <Calendar
                  className="custom-calendar"
                  cellRender={dateCellRender}
                  onSelect={onCalendarSelect}
                  onPanelChange={onPanelChange} // 월/연도 변경될 때
                />
              </div>
            </Content>
          </Col>
        </Row>
      </Content>
      <ModalLayout
        type="modal"
        centered
        title={'전체 판매내역'}
        open={isOpened && modalType === 'menusales'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={0} style={{ marginTop: 20 }}>
          <div>
            <Row>
              <Col span={6}>
                <p style={{ marginBottom: 5 }}>카테고리 별 필터</p>
                <Select
                  size="middle"
                  style={{ width: '100%', marginBottom: 20 }}
                  placeholder="상위 카테고리 선택 (선택사항)"
                  value={selectedCategory}
                  onChange={(value) => setSelectedCategory(value)}
                  options={[
                    { label: 'All', value: '' },
                    ...(categoryData?.map((category) => ({
                      label: category.product_category_name,
                      value: category.product_category_id,
                    })) || []),
                  ]}
                />
              </Col>
            </Row>
          </div>
          <Table
            data={filteredData} // 메뉴 데이터를 여기에 입력
            columns={[
              {
                title: '메뉴번호',
                key: 'menu_id',
                dataIndex: 'menu_id',
              },
              {
                title: '메뉴명',
                key: 'menu_name',
                dataIndex: 'menu_name',
              },
              {
                title: '판매수량',
                key: 'num',
                dataIndex: 'num',
                render: (item) => <span>{item}</span>,
              },
              {
                title: '메뉴가격',
                key: 'price',
                dataIndex: 'price',
                render: (price) => stringToMoneyFormat(price, '원'), // 가격 포맷
              },
            ]}
            minHeight={'auto'}
            minWidth={'100%'}
          />
        </Content>
      </ModalLayout>
    </>
  );
};

export default SalesStatusPresenter;
